import React from "react";

import { useTranslation } from "react-i18next";
import { StyledModal, StyledH2, StyledLabel } from "@aureskonnect/react-ui";
import { toast } from "react-toastify";
import { useSnapshot } from "valtio";

import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import storeVatRate, {
    setDataIsUpdatedFranchise,
    setDataIsUpdatedShops,
    setIsLoading,
} from "./store";
import { store } from "../../../components/VerticalLayout/store";
import { capitalize } from "@helpers/general";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { useFetchGlobal } from "../../../api/hooks";
import { showSuccessToast } from "@components/Common/SuccessToast";
import ErrorToast from "@components/Common/ErrorTost";

type ConfirmationFavoriteType = {
    isModalOpened: boolean;
    setIsModalOpened: Function;
    e: any;
};

export function ConfirmationFavorite({
    isModalOpened,
    setIsModalOpened,
    e,
}: ConfirmationFavoriteType) {
    const { fetchGlobal } = useFetchGlobal();
    const { t } = useTranslation();
    const { dataShops } = useSnapshot(storeVatRate);
    const { userID, franchiseID, operatorID } = useSnapshot(store);
    const uuidUser = localStorage.getItem("uuidUser");
    async function favoriteTva() {
        toast.dismiss();
        setIsLoading(true);
        try {
            const allVatRates: any[] = [];
            for (const shop of dataShops) {
                for (const tva of shop.subRows) {
                    let objectData: any = null;
                    if (e.selectedRow.Id === tva.Id && tva.archived === false) {
                        objectData = {
                            id: tva.Id,
                            code: tva.code,
                            value: tva.value,
                            tag: tva.tag,
                            status: true,
                            pays: tva.pays,
                            archived: tva.archived,
                            isFavorite: true,
                            shopId: shop.shopId,
                        };
                    } else if (
                        tva.isFavorite === true &&
                        shop.subRows.findIndex(
                            (elt: any) =>
                                elt.Id === e.selectedRow.Id &&
                                elt.archived === false
                        ) !== -1
                    ) {
                        objectData = {
                            id: tva.Id,
                            code: tva.code,
                            value: tva.value,
                            tag: tva.tag,
                            status: tva.status,
                            pays: tva.pays,
                            archived: tva.archived,
                            isFavorite: false,
                            shopId: shop.shopId,
                        };
                    }

                    if (objectData) {
                        allVatRates.push(objectData);
                    }
                }
            }

            const dataVatRate = {
                userId: userID,
                franchiseId: franchiseID,
                operatorId: operatorID,
                uuidUser: uuidUser,
                canReplace: false,
                data: allVatRates,
            };
            if (allVatRates.length > 0) {
                await fetchGlobal(
                    `${process.env.REACT_APP_API_V2_URL}/settings/general/editVatRate`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(dataVatRate),
                    }
                );
            }
            showSuccessToast(
                `${t("Modification was successfully carried out in stores")}`
            );
            setDataIsUpdatedFranchise!(true);
            setDataIsUpdatedShops(true);
        } catch (err: any) {
            ErrorToast(`${t("There's an error")!}`);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <StyledModal toggle={true} isOpen={isModalOpened!} centered>
            <ModalHeader
                className="text-capitalize"
                toggle={() => {
                    setIsModalOpened(!isModalOpened);
                }}
            >
                <StyledH2>{capitalize(t("Alert"))}</StyledH2>
            </ModalHeader>
            <ModalBody>
                <StyledLabel
                    className="pl-3 m-0"
                    style={{ whiteSpace: "pre-line" }}
                >
                    {t(
                        'Do you want to apply these changes for all stores? \n Attention ! If you click on "Validate", the specific settings of the shops will be modified.'
                    )}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={() => {
                        setIsModalOpened(!isModalOpened);
                        setDataIsUpdatedFranchise!(true);
                        setDataIsUpdatedShops(true);
                    }}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={() => {
                        favoriteTva();
                        setIsModalOpened(!isModalOpened);
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
